import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '@components/common/SEO'
import { Button } from '@components/ui/Button'

const NotFoundPage: React.FC = () => {
  return (
    <>
      <SEO
        title="ไม่พบหน้าที่ค้นหา"
        description="ขออภัย ไม่พบหน้าที่คุณต้องการ"
        noIndex
        noFollow
      />
      <div className="container-wrapper py-16 text-center">
        <div className="max-w-md mx-auto">
          <div className="text-6xl mb-4">🔍</div>
          <h1 className="text-4xl font-bold text-neutral-900 mb-4">404</h1>
          <h2 className="text-xl font-semibold text-neutral-700 mb-4">
            ไม่พบหน้าที่ค้นหา
          </h2>
          <p className="text-neutral-600 mb-8">
            ขออภัย หน้าที่คุณต้องการหาไม่มีอยู่ในระบบ
          </p>
          <div className="space-y-3">
            <Button asChild fullWidth>
              <Link to="/">กลับหน้าแรก</Link>
            </Button>
            <Button variant="outline" asChild fullWidth>
              <Link to="/search">ค้นหาบริษัท</Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default NotFoundPage